import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { map, keys } from 'lodash';
import { RadioButton } from 'sharedComponents';
import NotificationTypeList from './NotificationTypeListComponent';
import { digestOptions } from '../constants';
import {
    isDigestOptionSelected,
    updateDigestOption
} from './helpers';
import './style.scss';
import CopyNotificationSettingsDialog from './CopyNotificationSettingsDialog';
import { IconComputer, IconEnvelope, IconWebHooks } from 'svgIcons/MotionPortalIcons';
import { apiCallStatus } from 'helpers/constants';
import { useUserCapability } from 'sharedHooks';


const NotificationChannelsComponent = (props) => {
    const { t: translate } = useTranslation();
    const userCapabilities = useUserCapability();

    const {
        notificationChannels: notificationChannelState,
        notificationSettingsLoadingStatus,
        selectedNotificationGroups
    } = props.notificationSettings;

    const notificationChannels = notificationChannelState;

    const renderDigestOptions = () => {
        return notificationChannels?.summarySettings &&
            map(keys(digestOptions), (digestOptionKey) => {
                return <RadioButton
                    key={digestOptionKey}
                    id={digestOptionKey}
                    onClick={() => {
                        props.saveNotificationSettings(
                            props.organizationID,
                            updateDigestOption(notificationChannels, digestOptions[digestOptionKey]));
                    }}
                    checked={isDigestOptionSelected(notificationChannels?.summarySettings, digestOptions[digestOptionKey])}
                    label={translate(`ABB.Powertrain.Frontend.notificationsEmailDigest${digestOptions[digestOptionKey]}`)}
                    disabled={notificationSettingsLoadingStatus === apiCallStatus.LOADING}
                />;
            });
    };

    return <div className='notification-channels-container'>
        <div className='notification-channels-section'>
            <div className='title'>{translate('ABB.Powertrain.Frontend.notificationsEmailDigestTitle')}</div>
            <div className='description'>{translate('ABB.Powertrain.Frontend.notificationsEmailDigestDescription')}</div>
            {renderDigestOptions()}
        </div>
        <div className='notification-channels-section'>
            <div className='title'>{translate('ABB.Powertrain.Frontend.notificationsChannelInfoTitle')}</div>
            <div className='description'>{translate('ABB.Powertrain.Frontend.notificationsChannelInfoDescriptionUpdate')}</div>
            <div className='notification-boxes'>
                <div className='notification-box'>
                    <div className='notification-box-header'>
                        <div className='notification-box-icon'><IconComputer /></div>
                        <div className='notification-box-title'>{translate('ABB.Powertrain.Frontend.notificationChannelNotificationCenter')}</div>
                    </div>
                    <div className='notification-box-description'>{translate('ABB.Powertrain.Frontend.notificationChannelboxdescription')}</div>
                </div>
                <div className='notification-box'>
                    <div className='notification-box-header'>
                        <div className='notification-box-icon icon-email'><IconEnvelope height='16px' width='16px' /></div>
                        <div className='notification-box-title'>{translate('ABB.Powertrain.Frontend.notificationChannelEmail')}</div>
                    </div>
                    <div className='notification-box-description'>{translate('ABB.Powertrain.Frontend.notificationChannelEmailDescription')}</div>
                </div>
                {userCapabilities.hasntfChannelWebhookCapability() && <div className='notification-box'>
                    <div className='notification-box-header'>
                        <div className='notification-box-icon'><IconWebHooks /></div>
                        <div className='notification-box-title'>{translate('ABB.Powertrain.Frontend.notificationChannelWebhook')}</div>
                    </div>
                    <div className='notification-box-description'>{translate('ABB.Powertrain.Frontend.notificationChannelWebhooksDescription')}</div>
                </div>}
            </div>
        </div>
        <NotificationTypeList
            notificationChannels={notificationChannels}
            saveNotificationSettings={props.saveNotificationSettings}
            selectNotificationGroup={props.selectNotificationGroup}
            selectedNotificationGroups={selectedNotificationGroups}
            organizationID={props.organizationID}
            loading={notificationSettingsLoadingStatus}
        />
        <CopyNotificationSettingsDialog
            showCopyNotification={props.showCopyNotification}
            setShowCopyNotification={props.setShowCopyNotification}
            organizationID={props.organizationID}
            organizationList={props.organizationList}
            copyNotificationSettings={props.copyNotificationSettings}
            copySettingsDetails={props.copySettingsDetails}
        />
    </div>;
};

NotificationChannelsComponent.propTypes = {
    notificationSettings: PropTypes.shape({
        notificationChannels: PropTypes.object,
        notificationSettingsLoadingStatus: PropTypes.string,
        selectedNotificationGroups: PropTypes.array
    }),
    organizationID: PropTypes.number,
    saveNotificationSettings: PropTypes.func,
    selectNotificationGroup: PropTypes.func,
    organizationList: PropTypes.any,
    copyNotificationSettings: PropTypes.func,
    copySettingsDetails: PropTypes.object
};

export default NotificationChannelsComponent;
